module.exports = __webpack_public_path__ + "img/ubu.c61646b1.webp";